import { render, staticRenderFns } from "./index_News.vue?vue&type=template&id=174abcf1&scoped=true"
import script from "./index_News.vue?vue&type=script&lang=js"
export * from "./index_News.vue?vue&type=script&lang=js"
import style0 from "./index_News.vue?vue&type=style&index=0&id=174abcf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174abcf1",
  null
  
)

export default component.exports